export const CartIconDefault = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
<path d="M2.99962 9.29983H20.9996M6.59962 13.4998H9.59962M4.80009 5.09998H19.1997C20.5252 5.09998 21.5997 6.17365 21.5997 7.4991L21.6 16.501C21.6 17.8265 20.5255 18.9 19.2 18.9L4.80032 18.8998C3.47487 18.8998 2.40038 17.8253 2.40034 16.4999L2.40009 7.50004C2.40005 6.17453 3.47458 5.09998 4.80009 5.09998Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);
